import React, { Component } from 'react';
import { Translation } from 'react-i18next';

function Ans5() {
  return (
    <Translation>
      {(t) => (
        <div className="bg">
          <ol className="ans">
            <li>
              <b className="fisrt-line">{t('ans_4.text_1')}</b>
              <p>{t('ans_4.text_2')}</p>
            </li>

            <li>
              <b className="fisrt-line">{t('ans_4.text_22')}</b>
              <ul>
                <li>{t('ans_4.text_23')}</li>
                <li>{t('ans_4.text_24')}</li>
                <li>{t('ans_4.text_25')}</li>
                <li>{t('ans_4.text_26')}</li>
              </ul>
            </li>
          </ol>
        </div>
      )}
    </Translation>
  );
}

export default Ans5;
